import type { MapDef } from './types';

/*
 * נוצר ע"י scripts/genDuel.ts. מפה בינונית לקרב מהיר — כשליש מ-`ridgeline`,
 * אבל עם מספיק מרחק כדי לבנות בסיס לפני שנפגשים. טסט maps.test.ts אוכף
 * סימטריה, עבירות, חיבוריות וקרבת עפרות.
 *
 * '.' דשא   ',' חול   '~' מים   '#' סלע   'o' עפרות
 */
export const duel: MapDef = {
    id: 'duel',
    nameKey: 'map_duel',
    w: 56,
    h: 56,
    maxPlayers: 2,
    startSlots: [
        { x: 12, y: 13 },
        { x: 43, y: 42 },
    ],
    rows: [
        '........................................................',
        '........................................................',
        '........................................................',
        '........................................................',
        '........................................................',
        '........................................................',
        '...............................,........................',
        '.............................,,o,,......................',
        '.............................,ooo,......................',
        '............................,ooooo,.....................',
        '.............................,ooo,......................',
        '.............................,,o,,........#.............',
        '...............................,........#####...........',
        '.......................................#######..........',
        '.......................................#######..........',
        '......................................#########.........',
        '.......................................#######..........',
        '.......................................#######..........',
        '.......................................######...........',
        '...........,...........................#####............',
        '.........,,o,,........................#######...........',
        '........,ooooo,............,,..........#####............',
        '........,ooooo,.........,,,,,,,,.......#####............',
        '.......,ooooooo,.......,,,~~~~,,,........#..............',
        '........,ooooo,.......,,~~~~~~~~,,......................',
        '........,ooooo,.......,,~~~~~~~~,,......................',
        '.........,,o,,........,~~~~~~~~~~,......................',
        '...........,.........,,~~~~~~~~~~,,.....................',
        '.....................,,~~~~~~~~~~,,.........,...........',
        '......................,~~~~~~~~~~,........,,o,,.........',
        '......................,,~~~~~~~~,,.......,ooooo,........',
        '......................,,~~~~~~~~,,.......,ooooo,........',
        '..............#........,,,~~~~,,,.......,ooooooo,.......',
        '............#####.......,,,,,,,,.........,ooooo,........',
        '............#####..........,,............,ooooo,........',
        '...........#######........................,,o,,.........',
        '............#####...........................,...........',
        '...........######.......................................',
        '..........#######.......................................',
        '..........#######.......................................',
        '.........#########......................................',
        '..........#######.......................................',
        '..........#######.......................................',
        '...........#####........,...............................',
        '.............#........,,o,,.............................',
        '......................,ooo,.............................',
        '.....................,ooooo,............................',
        '......................,ooo,.............................',
        '......................,,o,,.............................',
        '........................,...............................',
        '........................................................',
        '........................................................',
        '........................................................',
        '........................................................',
        '........................................................',
        '........................................................',
    ],
};
